<template>
    <div class="gobuy">

        <div class="common-header-wrap">
            <mt-header :title="$t('Language selection')" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>

        <div class="list">
            <div class="item ds-button" v-for="(item, index) in list" :key="index" @click="change_lang(item.en)">
                <div class="icon">
                    <img :src="`https://ceshi.ceshiwang1.com/static/home/images/lang/${iconFun(item.en)}.png`" alt="">
                </div>
                <div class="text" v-if="item.en == 'en-us'">
                    En-us
                </div>
                <div class="text" v-else>
                    {{ item.en }}
                </div>
            </div>
        </div>
    </div>
</template>
  
<script>
import { Toast, MessageBox, Indicator } from 'mint-ui'
import { getLangList, change_lang } from '../../../api/homeindex'

export default {
    components: {
    },
    data() {
        return {
            list: [],
        }
    },
    computed: {
    },
    created() {
    },
    mounted() {
        this.getLangList()
        window.scrollTo(0, 0);
    },
    methods: {
        change_lang(lang) {
            if (this.utils.fetch('lang') == lang) return
            // 本地存储
            if (lang == 'en-us') {
                this.$i18n.locale = 'en'
                this.utils.save('lang', 'en')
                this.utils.save("locale", 'en');
            } else {
                this.$i18n.locale = lang
                this.utils.save('lang', lang)
                this.utils.save("locale", lang);
            }

            change_lang(lang).then(res => {
                if (res.code == 10000) {
                    Toast(res.message)
                    this.getLangList()

                    setTimeout(() => {
                        this.$router.go(-1)
                    }, 500);
                }
            })
        },
        getLangList() {
            getLangList().then(res => {
                this.list = res.result
            })
        },
        iconFun(en) {
            if (en == 'en-us') return 'en'
            if (en == 'Thai') return 'tai'
            if (en == 'Jap') return 'jap'
            if (en == 'Korean') return 'kr'
            if (en == 'Vietnamese') return 'vit'
            if (en == 'Indonesia') return 'bah'
            if (en == 'French') return 'fra'
            if (en == 'German') return 'deu'
            if (en == 'TW') return 'TW'
        },
    },
    beforeDestroy() {
    }
}
</script>
  
<style lang='scss' scoped>
[v-cloak] {
    display: none;
}

.gobuy {
    overflow: hidden;
    width: 100%;

    background: url('../../../assets/image/home/lang-bg.png') no-repeat;
    background-size: cover;
    position: relative;

    .common-header-wrap .common-header {
        box-shadow: unset;
        background: #f7e4d4;
    }

    .list {
        padding: 25px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        grid-gap: 20px;

        .item {
            background: #A62C22;
            border-radius: 15px 15px 15px 15px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin: 0 0 20px 0;
            padding: 18px 0;

            .icon {
                width: 52px;
                height: 32px;

                img {
                    width: 100%;
                    height: 100%;
                    display: block;
                }
            }

            .text {
                width: 6rem;
                margin-left: 15px;
                font-size: 24px;
                color: #FFFFFF;
            }
        }
    }
}
</style>
  